import { render, staticRenderFns } from "./ProductsClicked.vue?vue&type=template&id=fe7c6e42&scoped=true&"
import script from "./ProductsClicked.vue?vue&type=script&lang=js&"
export * from "./ProductsClicked.vue?vue&type=script&lang=js&"
import style0 from "./ProductsClicked.vue?vue&type=style&index=0&id=fe7c6e42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7c6e42",
  null
  
)

export default component.exports